module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('justifyLeft')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$parent.locale["left justify"]) + "\n    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('justifyCenter')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$parent.locale["center justify"]) + "\n    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.execCommand('justifyRight')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$parent.locale["right justify"]) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61b5f72c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/align/dashboard.vue
// module id = 652
// module chunks = 0